// extracted by mini-css-extract-plugin
module.exports = {"comment_section_container":"dece2e673c--comment_section_container--MBlW7","comment_section":"dece2e673c--comment_section--2sxsz","editable":"dece2e673c--editable--_de6X"};